// extracted by mini-css-extract-plugin
export default {"viewed":"MarkAsViewedButton-module__viewed__VcCRFcJ","iconOnly":"MarkAsViewedButton-module__iconOnly__JUtuioh"};